<template>
	<div class="popup popup--mini" @mousedown.self="$emit('close')">
		<div class="popup__block">
			<div class="popup__top">
				<div class="popup__title">Измененные товарные категории</div>
				<div class="popup__close" @click="$emit('close')"></div>
			</div>
			<div class="popup__content">
				<div class="notices-cat">
					<div class="notices-cat__list">
						<div v-for="item in productGroups" :key="item.id" class="notices-cat__item" :class="{'notices-cat__item--cancel': item.action === 'delete'}">
							{{ item.name }} (№{{ item.id }})
						</div>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'NoticesCategoriesPopup',
	props: {
		productGroups: {
			type: Array,
			default: () => []
		},
	},

}
</script>
